import plusIcon from "../assets/svg/plus-table.svg";

import { apiDeletePersons, apiGetPersons, apiGetPersonsExcel } from "../api/personApi";
import { apiDeleteManufactureOrder, apiManufactureOrder } from "api/manufactureOrderApi";
import ManufactureOrderStatus from "components/manufactureOrders/ManufactureOrderStatus";

const defaultManufactureOrderColumns = [
  {
    name: "وضعیت",
    key: "status", // پیش نویس / تایید شده
    Component: ManufactureOrderStatus,
  },
  {
    name: "شماره",
    key: "accountingCode",
    // filterParams: {
    //   column: "accountingCode",
    //   columnType: "string",
    // },
  },
  {
    name: "تاریخ شروع",
    key: "date",
  },
  {
    name: "نام کالا تولیدی",
    key: "Product", // getValue title
    getValue: (item) => {
      return item?.Product?.title ?? "-";
    },
  },
  {
    name: "عنوان فرمول تولید",
    key: "Production_Formula",
    getValue: (item) => {
      return item?.Production_Formula?.title ?? "-";
    },
  },
  {
    name: "مقدار",
    key: "quantity",
    price: true,
  },
  {
    name: "قیمت کل",
    key: "price",
    price: true,
  },
];

export const manufactureOrderIndexData = [
  {
    key: "all",
    label: "همه",
    pluralLabel: "همه",
    title: "همه",
    pageTitle: "سفارشات تولید",
    pageDescription: "نمایش لیست سفارشات تولید شده",
    tableColumns: defaultManufactureOrderColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/manufacture/orders/add", // set add order form
      },
      fetch: apiManufactureOrder,
      delete: apiDeleteManufactureOrder,
      excel: {
        // export: apiGetPersonsExcel,
        // import: apiGetPersonsExcel,
      },
    },
  },
  {
    key: "estimate",
    label: "در جریان",
    pluralLabel: "در جریان",
    title: "در جریان",
    pageTitle: "سفارشات تولید",
    pageDescription: "نمایش لیست سفارشات تولید شده",
    tableColumns: defaultManufactureOrderColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/persons/add",
      },
      edit: {},
      fetch: apiManufactureOrder,
      delete: apiDeleteManufactureOrder,
      excel: {
        export: apiGetPersonsExcel,
        import: apiGetPersonsExcel,
      },
    },
  },
  {
    key: "done",
    label: "تمام شده",
    pluralLabel: "تمام شده",
    title: "تمام شده",
    pageTitle: "سفارشات تولید",
    pageDescription: "نمایش لیست سفارشات تولید شده",
    tableColumns: defaultManufactureOrderColumns,
    disableDateFilter: true,
    actions: {
      add: {
        title: "افزودن",
        icon: plusIcon,
        url: "/persons/add",
      },
      fetch: apiManufactureOrder,
      delete: apiDeleteManufactureOrder,
      excel: {
        export: apiGetPersonsExcel,
        import: apiGetPersonsExcel,
      },
    },
  },
];
